import { render } from "./warn_title.vue?vue&type=template&id=25aeaa9b&scoped=true"
const script = {}

import "./warn_title.vue?vue&type=style&index=0&id=25aeaa9b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25aeaa9b"]])

export default __exports__